var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDuplicateOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33341 10.6667H4.00008C3.64646 10.6667 3.30732 10.5262 3.05727 10.2761C2.80722 10.0261 2.66675 9.68695 2.66675 9.33333V4C2.66675 3.64638 2.80722 3.30724 3.05727 3.05719C3.30732 2.80714 3.64646 2.66666 4.00008 2.66666H9.33341C9.68704 2.66666 10.0262 2.80714 10.2762 3.05719C10.5263 3.30724 10.6667 3.64638 10.6667 4V5.33333M6.66675 13.3333H12.0001C12.3537 13.3333 12.6928 13.1929 12.9429 12.9428C13.1929 12.6928 13.3334 12.3536 13.3334 12V6.66666C13.3334 6.31304 13.1929 5.9739 12.9429 5.72386C12.6928 5.47381 12.3537 5.33333 12.0001 5.33333H6.66675C6.31313 5.33333 5.97399 5.47381 5.72394 5.72386C5.47389 5.9739 5.33341 6.31304 5.33341 6.66666V12C5.33341 12.3536 5.47389 12.6928 5.72394 12.9428C5.97399 13.1929 6.31313 13.3333 6.66675 13.3333Z",
    stroke: "#09090B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuplicateOutline);
export default __webpack_public_path__ + "static/media/DuplicateOutline.c9f5690b583976b8122cf56e10f2cae1.svg";
export { ForwardRef as ReactComponent };